var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.options,"multiple":_vm.multiple,"label":_vm.label,"value":_vm.selectedOption,"placeholder":_vm.placeholder},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }